module.exports = __webpack_public_path__ + "img/24. Close.e7780f2d.svg";